var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.287 5.851"}},[_c('path',{attrs:{"data-name":"Path 1","d":"m.354.354 4.79 4.79 4.79-4.79","fill":"none","stroke":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }